(function () {
  calendarHeader.$inject = ["API_URL", "$rootScope", "$cookies", "$location"];
  angular.module('calendarApp').directive('calendarHeader', calendarHeader);

  function calendarHeader(API_URL, $rootScope, $cookies, $location) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/calendar-header.html',
      scope: {
        days: '=',
        home: '='
      },
      link: function link(scope, elem, attrs) {
        scope.header = scope;
        scope.customerInfo = $rootScope.customerInfo;
        scope.$watch('days', showNextPrevious);

        function showNextPrevious() {
          if (!scope.home.days || !scope.home.days.length) {
            return;
          }

          scope.showPrevious = true;
          scope.showNext = true;
          var startDate = moment(scope.home.days[0].date);

          if (startDate.isSameOrBefore(moment(scope.home.daysAvailable[0]))) {
            scope.showPrevious = false;
          }

          var lastAvailableDay = moment(scope.home.daysAvailable[scope.home.daysAvailable.length - 1]);

          if (moment(scope.home.days[scope.home.days.length - 1].date).isSameOrAfter(lastAvailableDay)) {
            scope.showNext = false;
          }
        }

        scope.removeFilter = function (type) {
          if (type === 'service') {
            scope.home.chosenService = '1';
            $location.search('serviceid', null);
          }

          if (type === 'resource') {
            scope.home.chosenResource = '1';
            $location.search('resourceid', null);
          }

          if (type == 'date') {
            scope.home.chosenDate = null;
            $location.search('date', null);
          }
        };

        $rootScope.$watch('customerInfo', function () {
          scope.customerInfo = $rootScope.customerInfo;
        });
      }
    };
  }
})();